import { Component, inject } from '@angular/core';
import { MovementTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  MovementTypeCreateDto,
  MovementTypeDto,
  MovementTypeExcelDownloadDto,
  MovementTypeUpdateDto,
} from '../proxy/controlling/dtos/movement-type';
import { MOVEMENTTYPE_CONFIG, MOVEMENTTYPE_FIELDS } from './movement-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-movement-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, MovementTypeService, ConfirmationService],
  templateUrl: './movement-type.html',
  styleUrl: './movement-type.scss',
})
export class MovementType extends BaseCrudComponent<
  MovementTypeDto,
  MovementTypeCreateDto,
  MovementTypeUpdateDto,
  MovementTypeExcelDownloadDto
> {
  service = inject(MovementTypeService);
  config = MOVEMENTTYPE_CONFIG;
  fields = MOVEMENTTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: MovementTypeDto): MovementTypeUpdateDto {
    return {
      sapCode: data.sapCode,
      description: data.description,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'MovementType';
  }
}
